// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body__preview[data-v-168d34f2] {\n  font-size: 1rem;\n}", ""]);
// Exports
module.exports = exports;
